var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.2008C18.1856 23.2008 23.2 18.1864 23.2 12.0008C23.2 5.81519 18.1856 0.800781 12 0.800781C5.8144 0.800781 0.799988 5.81519 0.799988 12.0008C0.799988 18.1864 5.8144 23.2008 12 23.2008ZM17.3992 9.46836C17.7402 8.99938 17.6366 8.34269 17.1676 8.00161C16.6986 7.66053 16.0419 7.76422 15.7008 8.2332L10.8236 14.9394L8.19245 12.3083C7.7824 11.8983 7.11758 11.8983 6.70753 12.3083C6.29748 12.7184 6.29748 13.3832 6.70753 13.7932L10.2075 17.2932C10.4247 17.5104 10.726 17.6216 11.0321 17.5976C11.3383 17.5735 11.6185 17.4167 11.7992 17.1684L17.3992 9.46836Z",
    fill: "#699F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreen);
export default __webpack_public_path__ + "static/media/checkmarkGreen.f24d2b59500cd81a75e56063eb9de248.svg";
export { ForwardRef as ReactComponent };